import { useState } from "react"
import { useTranslation } from "react-i18next"
import { useLocation, useNavigate } from "react-router-dom"
import Select, { components } from "react-select"

import { getEnabledLanguages, getSortedLanguages } from "../../helpers/general"
import useScroll from "../../hooks/use-Scroll"
import locales from "../../locales"
import CaretDownIcon from "../CaretDownIcon/CaretDownIcon"

import styles from "./LanguageSwitcher.module.scss"

let enabledLanguages = getEnabledLanguages(locales)
enabledLanguages = getSortedLanguages(enabledLanguages)

const LanguageSwitcher = () => {
  const { i18n } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const handleChange = option => {
    const { value } = option

    const pathnameSplit = location.pathname.split(`/${i18n.language}/`)
    const newPathname =
      pathnameSplit.length > 1 ? `/${value}/${pathnameSplit[1]}` : `/${value}`

    i18n.changeLanguage(value)
    navigate(newPathname)
  }
  const y = useScroll()

  const DropdownIndicator = props => {
    return (
      <components.DropdownIndicator {...props}>
        <CaretDownIcon />
      </components.DropdownIndicator>
    )
  }
  const options =
    enabledLanguages && Object.keys(enabledLanguages)?.length > 0
      ? Object.keys(enabledLanguages).map(lng => {
          return { value: lng, label: lng }
        })
      : null

  // const currentLanguageName =
  //   enabledLanguages?.[i18n.language]?.nativeName ?? "-"
  const currentLanguageName = i18n.language
  const mediaWith = 993;
  const onMenuOpen = () => {
    setIsMenuOpen(true)
  }
  const onMenuClose = () => setIsMenuOpen(false)

  const isScrollingSmallDevice = y > 2 && window.innerWidth < mediaWith

  const customStyles = {
    menuList: (base) => {
      const isTablet = typeof window !== 'undefined' && window.matchMedia(`(max-width: ${mediaWith}px)`).matches;
      return {
        ...base,
        paddingTop: isTablet ? '10px' : (base.paddingTop || '12px'),
        paddingBottom: isTablet ? '20px' : (base.paddingBottom || '12px'),
        paddingLeft: isTablet ? '20px' : '4px',
        paddingRight: isTablet ? '20px' : '4px',
      };
    },
  };

  if (!options || options.length <= 0) {
    return ""
  }

  return (
    <Select
      placeholder={currentLanguageName}
      components={{ DropdownIndicator }}
      defaultValue={i18n.language}
      onChange={handleChange}
      options={options}
      className={[
        styles.select,
        isMenuOpen ? styles.menuOpen : " ",
        isScrollingSmallDevice ? styles.scrolling : " ",
      ].join(" ")}
      styles={customStyles}
      onMenuOpen={onMenuOpen}
      onMenuClose={onMenuClose}
      isSearchable={false}
    />
  )
}

export default LanguageSwitcher
